import { DuplicateJournalResultEntity } from "../../entities/JournalEntity";
import { JournalRepository } from "../../repositories/JournalRepository";

export class DuplicateJournalUseCase {
  constructor(private repository: JournalRepository) {}

  async execute(journalId: number): Promise<DuplicateJournalResultEntity> {
    if (!Number.isInteger(journalId) || journalId <= 0) {
      throw new Error("A valid journal ID is required.");
    }

    return await this.repository.duplicateJournal(journalId);
  }
}
